var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      ref: "modal",
      attrs: { size: "xl", centered: "", "body-class": "c-preview" },
      on: { hide: _vm.closeHandler, show: _vm.showHandler },
      scopedSlots: _vm._u([
        {
          key: "modal-title",
          fn: function () {
            return [
              _vm._v("\n    Preview\n    "),
              _vm.fileName
                ? _c(
                    "span",
                    {
                      staticClass:
                        "d-block small text-muted text-wrap text-break font-weight-normal",
                    },
                    [_vm._v("\n      " + _vm._s(_vm.fileName) + "\n    ")]
                  )
                : _vm._e(),
            ]
          },
          proxy: true,
        },
        {
          key: "modal-footer",
          fn: function () {
            return [
              _c(
                "ButtonPrimary",
                { attrs: { variant: "primary" }, on: { click: _vm.download } },
                [_vm._v("\n      Download\n    ")]
              ),
              _vm._v(" "),
              _c(
                "ButtonOutline",
                {
                  attrs: { variant: "outline-primary" },
                  on: {
                    click: function ($event) {
                      return _vm.$refs.modal.hide()
                    },
                  },
                },
                [_vm._v("\n      Cancel\n    ")]
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm._v(" "),
      _c(
        "b-tabs",
        {
          staticClass: "preview-tabs",
          attrs: { "no-nav-style": !_vm.hasMetaproperties },
          model: {
            value: _vm.activeTab,
            callback: function ($$v) {
              _vm.activeTab = $$v
            },
            expression: "activeTab",
          },
        },
        [
          _c(
            "b-tab",
            {
              attrs: {
                title: _vm.hasMetaproperties ? "Preview" : null,
                active: "",
              },
            },
            [
              _c(
                "div",
                { staticClass: "c-preview" },
                [
                  _vm.imageType
                    ? _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.isLoading,
                            expression: "!isLoading",
                          },
                        ],
                        staticClass: "c-preview__body",
                        attrs: { src: _vm.src, alt: "" },
                        on: { load: _vm.loaded, error: _vm.error },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.videoType
                    ? _c("video", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.isLoading,
                            expression: "!isLoading",
                          },
                        ],
                        staticClass: "c-preview__body",
                        attrs: { src: _vm.src, controls: "", muted: "" },
                        domProps: { muted: true },
                        on: { loadeddata: _vm.loaded, error: _vm.error },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.audioType
                    ? _c("audio", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.isLoading,
                            expression: "!isLoading",
                          },
                        ],
                        staticClass: "c-preview__body",
                        attrs: { src: _vm.src, controls: "", muted: "" },
                        on: { loadeddata: _vm.loaded, error: _vm.error },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.pdfType
                    ? _c("iframe", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.isLoading,
                            expression: "!isLoading",
                          },
                        ],
                        staticClass: "c-preview__body",
                        attrs: {
                          src: _vm.src,
                          frameborder: "0",
                          width: "100%",
                          height: "100%",
                        },
                        on: { load: _vm.loaded, error: _vm.error },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isLoading ? _c("b-spinner") : _vm._e(),
                  _vm._v(" "),
                  _vm.isError
                    ? _c(
                        "b-alert",
                        { attrs: { variant: "danger", show: "" } },
                        [
                          _vm._v(
                            "\n          Content is broken or not supported\n        "
                          ),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _vm.hasMetaproperties
            ? _c("b-tab", { attrs: { title: "Properties" } }, [
                _c(
                  "div",
                  { staticClass: "metaproperties-content" },
                  [
                    _c("MetapropertiesTable", {
                      attrs: { metaproperties: _vm.payload.metaproperties },
                    }),
                  ],
                  1
                ),
              ])
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }